// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"R5pj8p"};